import React from 'react';

export const Home = (props) => {
    return ( 
        <h1>EVBI</h1>

     );
}
 